import imgDVW from '../images/avocats/dimitri-van-wymeersch.jpg';
import imgJFG from '../images/avocats/jean-francois-gailly.jpg';
import imgMAO from '../images/avocats/maite-abad-et-ortega.jpg';
import imgHUR from '../images/avocats/hugue-radelet.jpg';
import imgSAH from '../images/avocats/sadia-hartouane.jpg';

const Attorneys = [
	{
		Id: '1',
		AtImg: imgJFG,
		name: 'Jean-François Gailly',
		slug: 'jean-françois-gailly',
		practice: [
			'Droit des assurances et réparation du dommage',
			'Droit de la circulation routière',
			'Droit de la responsabilité',
			'Droit des contrats (bail, entreprise, construction, vente, etc.)',
			"Copropriété d'appartements (syndic, troubles de voisinage, ...)",
			'Saisies, recouvrement de créances',
		],
		phone: '+32 (0) 71.70.02.02',
		email: 'secretariat@gava-lex.be',
		startYear: '1980-09-01',
		lang: ['Français', 'Néerlandais', 'Anglais', 'Italien (notions)'],
		comp: 'AttorneyGA',
	},
	{
		Id: '2',
		AtImg: imgDVW,
		name: 'Dimitri Van Wymeersch',
		slug: 'dimitri-van-wymeersch',
		practice: [
			'Droit des assurances et réparation du dommage',
			'Droit de la circulation routière',
			'Droit familial',
			'Droit de la jeunesse',
			'Droit pénal',
			'Droit de la responsabilité',
		],
		phone: '+32 (0) 71.70.02.02',
		email: 'secretariat@gava-lex.be',
		startYear: '2009-10-05',
		lang: ['Français', 'Néerlandais (notions)', 'Anglais (notions)'],
		comp: 'AttorneyVA',
	},
	{
		Id: '3',
		AtImg: imgMAO,
		name: 'Maïté Abad Et Ortega',
		slug: 'maite-abad-et-ortega',
		practice: [
			'Droit des assurances',
			'Droit de la circulation routière',
			'Droit civil',
			'Droit de la jeunesse',
			'Droit de la responsabilité',
		],
		phone: '+32 (0) 71.70.02.02',
		email: 'secretariat@gava-lex.be',
		startYear: '2014-09-01',
		lang: ['Français'],
		comp: 'AttorneyMAO',
	},
	{
		Id: '4',
		AtImg: imgHUR,
		name: 'Hugue Radelet',
		slug: 'hugue-radelet',
		practice: [
			'Droit de la circulation routière',
			'Droit des assurances',
			'Droit de la responsabilité',
			'Droit pénal',
		],
		phone: '+32 (0) 71.70.02.02',
		email: 'secretariat@gava-lex.be',
		startYear: '2021-10-08',
		lang: ['Français', 'Anglais', 'Espagnol (notions)'],
		comp: 'AttorneyHR',
	},
	{
		Id: '5',
		AtImg: imgSAH,
		name: 'Sadia Hartouane',
		slug: 'sadia-hartouane',
		practice: [
			'Droit des assurances et réparation du dommage',
			'Droit de la circulation routière',
			'Droit familial',
			'Droit de la jeunesse',
			'Droit pénal',
			'Droit de la responsabilité',
		],
		phone: '+32 (0) 71.70.02.02',
		email: 'secretariat@gava-lex.be',
		startYear: '2025-07-01',
		lang: ['Français', 'Anglais (notions)'],
		comp: 'AttorneySAH',
	},
];

export default Attorneys;
